import { Component } from '@angular/core';
import { IonicPage, NavController, ModalController, Events } from 'ionic-angular';
import { UserModel } from '../../providers/user/user.model';
import { UserProvider } from '../../providers/user/user.provider';
import { AuthProvider } from '../../providers/auth/auth.provider';
import { AccountUpdatePage } from '../account-update/account-update';
import { EventsProvider } from '../../providers/events/events.provider';
import { AccountOptionsPage } from '../account-options/account-options';

/**
 * Generated class for the AccountPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-account',
  templateUrl: 'account.html',
})
export class AccountPage {
  events_list:any;
  user: any = null;
  // [
  //   '📷 Photos',
  //   '⚽ Sport',
  //   'Lecture',
  //   'Voyages',
  //   'Sorties',
  //   'High Tech'
  // ]

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public userProvider: UserProvider,
    public eventsProvider: EventsProvider,
    public modalCtrl: ModalController, 
    public authProvider: AuthProvider
  ) {}

  ionViewDidEnter(){
    console.log("ionViewDidEnter");
    this.refresh();
  }

  async refresh(){
    // console.log("refresh");
    this.user = await this.userProvider.getUser();
    this.events_list = await this.eventsProvider.getEvents();
    
    console.log("this.user",this.user);
  }

  goToOptions(){
    this.navCtrl.push(AccountOptionsPage);
  }

  async goToAccountUpdate(){

    let accountUpdateModal = this.modalCtrl.create(AccountUpdatePage,{});
    accountUpdateModal.present();
    accountUpdateModal.onDidDismiss(async data => {
      // console.log("data",data);
      this.refresh();
    });
  }
  logout(){
    this.events.publish('user:logout');
    this.userProvider.setUser(null);
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/account.ts